<template>
    <div class="services">
        <el-dialog title="" :show-close="false"
                   custom-class="services"
                   :visible.sync="hasDisplayDesc">
            <div class="title">长按或扫码，添加人工客服</div>
            <div class="text-center">
                <img class="image" :src="imgSrc">
            </div>
            <div class="close" @click="hide"></div>
        </el-dialog>
    </div>
</template>
<script>
  import App from '../util/comfun'
  export default {
    props:{

    },
    data () {
      return {
        imgSrc:'https://assets.pfotoo.com/images/version/qrcode-qy.png',
        hasDisplayDesc:false
      }
    },
    components:{
    },
    methods:{
        show(params){
          if(params && params.imgSrc){
            this.imgSrc=params.imgSrc
          }
          this.hasDisplayDesc=true
        },
      hide(){
        this.hasDisplayDesc=false
      },
    },
    created(){

    },
  }
</script>
<style>
    .services .el-dialog{
        width: 315px;
        height: 352px;
        background-image: linear-gradient(138deg, #D3EEDF 0%, #FBFDFD 100%);
        border-radius: 5px;
        text-align: center;
        position: relative;
    }
    .services .title{
        height: 22px;
        opacity: 0.8;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #3DC4A7;
        letter-spacing: 0.5px;
        text-align: center;
    }
    .services .image{
        width: 180px;
        height: 180px;
        margin-top: 30px;
    }
    .services .close{
        position: absolute;
        right:15px;
        top:15px;
        background-image: url("https://assets.pfotoo.com/images/version/a9222631e6d96a459e3cd2d00551fe56.png");
        width: 20px;
        height: 20px;
        background-size: 100% 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/service-dialog.vue